/** @format */

import { Column, Line } from "@ant-design/charts";
import { Card } from "antd";
import { formatCurr } from "utils/helper";

type CardChartProps = {
  title: string;
  data: any[];
  loading?: boolean;
  type: "column" | "line";
};

const transformChartData = (data: any[], chartType: "column" | "line") => {
  if (chartType === "column") {
    return data.flatMap((item) => [
      {
        category: item.namaSumberDana,
        name: "Anggaran Pendapatan",
        value: item.anggaranPendapatan || 0,
      },
      {
        category: item.namaSumberDana,
        name: "Realisasi Pendapatan",
        value: item.realisasiPendapatan || 0,
      },
      {
        category: item.namaSumberDana,
        name: "Anggaran Belanja",
        value: item.anggaranBelanja || 0,
      },
      {
        category: item.namaSumberDana,
        name: "Realisasi Belanja",
        value: item.realisasiBelanja || 0,
      },
      {
        category: item.namaSumberDana,
        name: "Anggaran Sisa",
        value: item.anggaranSisa || 0,
      },
      {
        category: item.namaSumberDana,
        name: "Realisasi Sisa",
        value: item.realisasiSisa || 0,
      },
    ]);
  }

  return data.flatMap((item) => [
    {
      category: item.bulan,
      name: "Total Rencana Belanja",
      value: item.totalRencanaBelanja || 0,
    },
    {
      category: item.bulan,
      name: "Total Realisasi Belanja",
      value: item.totalRealisasiBelanja || 0,
    },
  ]);
};

export const CardChart = ({ title, data, loading, type }: CardChartProps) => {
  const chartData = transformChartData(data, type);

  const commonConfig = {
    data: chartData,
    xField: "category",
    yField: "value",
    seriesField: "name",

    legend: {
      position: "top" as const,
    },

    yAxis: {
      label: {
        formatter: (v: any) => formatCurr(Number(v)),
      },
    },

    tooltip: {
      formatter: (datum: any) => ({
        name: datum.name,
        value: formatCurr(datum.value),
      }),
    },
  };

  return (
    <Card
      title={title}
      headStyle={{ fontWeight: "bold" }}
      className="mb-4"
      loading={loading}>
      {type === "column" ? (
        <Column
          {...commonConfig}
          isGroup
          color={[
            "#388e3c",
            "#81c784",
            "#1565c0",
            "#64b5f6",
            "#b81e1e",
            "#e57373",
          ]}
        />
      ) : (
        <Line
          {...commonConfig}
          animation={{
            appear: {
              animation: "path-in",
            },
          }}
        />
      )}
    </Card>
  );
};
